import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Airports} from "@app/models";
import {Subscription} from "rxjs";
import {GlobalsService} from "@services/micro/globals.service";
import {unsubscribe} from "@app/utils";
/**
  Componente que muestra información sobre un tramo de vuelo, incluyendo las ciudades de llegada y salida.
  Este componente utiliza el servicio de traducción para mostrar los nombres de las ciudades en el idioma actual
  y se suscribe a cambios en el idioma para actualizar dinámicamente la información.
**/
@Component({
    selector: 'app-am-leg-flight',
    templateUrl: './am-leg-flight.component.html',
    styleUrls: ['./am-leg-flight.component.scss'],
    standalone: false
})
export class AmLegFlightComponent implements OnInit,  OnDestroy {
/**
    Código del aeropuerto de llegada.
    @type {string}
  **/
    @Input() arrival: string;

    /**
      Código del aeropuerto de salida.
      @type {string}
    **/
    @Input() departure: string;
  
    /**
      Idioma actual seleccionado en la aplicación.
      @type {string}
      @private
    **/
    currentLang = '';
  
    /**
      Nombre de la ciudad de llegada en el idioma actual.
      @type {string}
      @private
    **/
    arrivalCity = '';
  
    /**
      Nombre de la ciudad de salida en el idioma actual.
      @type {string}
      @private
    **/
    deparureCity = '';
  
    /**
      Lista de suscripciones para gestionar la desuscripción en el ciclo de vida del componente.
      @type {Subscription[]}
      @private
    **/
    subs: Subscription[] = [];
  constructor(private lang: TranslateService, private _globalService: GlobalsService) {
    const sub = this._globalService.language$.subscribe({
      next:(lang) => {
        this.currentLang = lang.replace("-", "_");
      }
    })
    this.subs.push(sub)

  }

  ngOnInit(): void {
    this.arrivalCity = Airports.findAriportByCode(this.arrival)[this.currentLang];
    this.deparureCity = Airports.findAriportByCode(this.departure)[this.currentLang];
  }

  ngOnDestroy() {
    unsubscribe(this.subs);
  }

}
